"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Menu = void 0;
var _table = _interopRequireDefault(require("../table"));
var _vXETable = _interopRequireDefault(require("../v-x-e-table"));
var _panel = _interopRequireDefault(require("./src/panel"));
var _mixin = _interopRequireDefault(require("./src/mixin"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Menu = {
  Panel: _panel.default,
  install: function install(Vue) {
    _vXETable.default.reg('menu');
    _table.default.mixins.push(_mixin.default);
    Vue.component(_panel.default.name, _panel.default);
  }
};
exports.Menu = Menu;
var _default = Menu;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/.store/vxe-table@3.7.6/~/vxe-table/lib/menu/index.js
// module id = 996
// module chunks = 75